import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import FontBody4 from '../../../../../../../components/fonts/font-body4/font-body4';
import FontHeading2 from '../../../../../../../components/fonts/font-heading2/font-heading2';
import FontHeading4 from '../../../../../../../components/fonts/font-heading4/font-heading4';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';
import { Badge, BadgeType } from '../../../../../../../components/badge/badge';
import { decimalFormat } from '../../../../../../../services/helpers';

import { IAmountTaxDto } from '../../../refund-calculator-types';

import './calculator-totals.scss';

interface ICalculatorTotalsProps {
    subtotal: IAmountTaxDto;
    total: number;
}

const CalculatorTotals: React.FC<ICalculatorTotalsProps> = ({ subtotal, total }) => {
    const isRefund = Number(total) > 0;
    const formattedSubtotalAmount = Number(decimalFormat(subtotal.amount, 3));
    const formattedSubtotalTax = Number(decimalFormat(subtotal.tax, 3));
    const formattedTotalAmount = Number(decimalFormat(total, 3));

    return (
        <div className="refund-calculator__totals">
            <div className="refund-calculator__breakdown-grid">
                <div className="refund-calculator__breakdown-grid-item start">
                    <FontHeading4 color={FONT_COLOR.NEUTRAL3}>Subtotal</FontHeading4>
                </div>
                <div className="refund-calculator__breakdown-grid-item end">
                    <FontBody2>{formattedSubtotalAmount}</FontBody2>
                </div>
                <div className="refund-calculator__breakdown-grid-item end">
                    <FontBody2>
                        {formattedSubtotalTax || "-"}
                        {subtotal.tax_rate ? (
                            <FontBody4 variant={FONT_VARIANT.DEFAULT} color={FONT_COLOR.NEUTRAL10}>&nbsp;{subtotal.tax_rate}%</FontBody4>
                        ) : null}
                    </FontBody2>
                </div>
            </div>

            <div className="refund-calculator__breakdown-grid">
                <div className="refund-calculator__breakdown-grid-item start">
                    <FontHeading2 variant={FONT_VARIANT.BOLD}>Total</FontHeading2>
                    <span className="refund-calculator__category-badge">
                        <Badge type={isRefund ? BadgeType.WARNING : BadgeType.PRIMARY} text={isRefund ? 'Refund' : 'Invoice'} />
                    </span>
                </div>
                <div className="refund-calculator__breakdown-grid-item end"></div>
                <div className="refund-calculator__breakdown-grid-item end">
                    <FontHeading2 color={FONT_COLOR.PRIMARY1} variant={FONT_VARIANT.BOLD}>{formattedTotalAmount}</FontHeading2>
                </div>
            </div>
        </div>
    );
};

export default CalculatorTotals;
